
// import { useState, useEffect } from "react";
// import { X, UploadCloud } from "lucide-react";
// import { useBanner } from "../context/BannerContext";
// import toast from "react-hot-toast";

// export default function AddBannerModal({ close, editData }) {
//   const { addBanner, updateBanner } = useBanner();

//   const [title, setTitle] = useState("");
//   const [placement, setPlacement] = useState("Home Page");
//   const [image, setImage] = useState("");


//   useEffect(() => {
//     if (editData) {
//       setTitle(editData.title);
//       setPlacement(editData.placement);
//       setImage(editData.image);

//     }
//   }, [editData]);

//   const uploadImage = (e) => {
//     const file = e.target.files[0];
//     const reader = new FileReader();
//     reader.onloadend = () => setImage(reader.result);
//     if (file) reader.readAsDataURL(file);
//   };

//  const saveBanner = () => {
//   if (!title || !image) {
//     toast.error("Fill all fields ");
//     return;
//   }

//   if (editData) {
//     updateBanner({
//       ...editData,
//       title,
//       placement,
//       image,
//     });

//     toast.success("Banner updated successfully ");
//   } else {
//     addBanner({
//   id: Date.now(),
//   title,
//   placement,
//   image,
//   status: true, 
// });
//     toast.success("Banner added successfully ");
//   }

//   close();
// };

//   return (
//     <div className="fixed inset-0 bg-black/40 z-[9999] overflow-y-auto p-4 flex items-start md:items-center justify-center">

//       <div className="bg-white w-full max-w-2xl rounded-2xl p-6 max-h-[90vh] overflow-y-auto">

//         <div className="flex justify-between items-start mb-6">
//           <div>
//             <h2 className="text-xl font-semibold">
//               {editData ? "Edit Banner" : "Add Banner"}
//             </h2>
//           </div>

//           <button onClick={close}>
//             <X />
//           </button>
//         </div>

//         <div className="mb-5">
//           <label className="text-sm font-medium">Banner Title</label>
//           <input
//             className="w-full border rounded-md p-3 mt-2"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//           />
//         </div>

//         <div className="mb-5">
//           <label className="text-sm font-medium">Upload Banner Image</label>

//           <label className="border-dashed border-2 rounded-lg p-10 flex flex-col items-center mt-2 cursor-pointer">
//             {image ? (
//               <img src={image} className="h-32 object-cover rounded-md" />
//             ) : (
//               <>
//                 <UploadCloud size={30} className="text-green-600 mb-2" />
//                 <p>Click or drag image to upload</p>
//               </>
//             )}
//             <input type="file" hidden onChange={uploadImage} />
//           </label>
//         </div>



//         <div className="mb-6">
//           <label className="text-sm font-medium">Placement</label>
//           <select
//             className="w-full border rounded-md p-3 mt-2"
//             value={placement}
//             onChange={(e) => setPlacement(e.target.value)}
//           >
//             <option>Home Page</option>
//             <option>About us</option>
//           </select>
//         </div>

//         <div className="flex justify-between items-center border-t pt-4">
//           <button onClick={close}>Cancel</button>

//           <button
//             onClick={saveBanner}
//             className="bg-[#3fa000] text-white px-6 py-2 rounded-md"
//           >
//             Save Banner
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import { X, UploadCloud } from "lucide-react";
// import toast from "react-hot-toast";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";

// export default function AddBannerModal({ close, editData, }){
//   const [title, setTitle] = useState("");
//   const [placement, setPlacement] = useState("Home Page");
//   const [image, setImage] = useState(null);
//   const [preview, setPreview] = useState("");

//   useEffect(() => {
//     if (editData) {
//       setTitle(editData.title);
//       setPlacement(editData.placement);

//       // support both url object and string
//       setPreview(editData.image?.url || editData.image);
//     }
//   }, [editData]);

//   const uploadImage = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImage(file);
//     setPreview(URL.createObjectURL(file));
//   };

//   const saveBanner = async () => {
//     try {
//       if (!title) {
//         toast.error("Fill all fields");
//         return;
//       }

//       const formData = new FormData();
//       formData.append("title", title);
//       formData.append("placement", placement);

//       if (image) {
//         formData.append("image", image);
//       }

//       if (editData) {
//         await api({
//           url: SummaryApi.updateBanner.url(editData.id || editData._id),
//           method: SummaryApi.updateBanner.method,
//           data: formData,
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         toast.success("Banner updated successfully");
//       } else {
//         await api({
//           url: SummaryApi.createBanner.url,
//           method: SummaryApi.createBanner.method,
//           data: formData,
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         toast.success("Banner added successfully");
//       }




//   return (
//     <div className="fixed inset-0 bg-black/40 z-[9999] overflow-y-auto p-4 flex items-start md:items-center justify-center">
//       <div className="bg-white w-full max-w-2xl rounded-2xl p-6 max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-start mb-6">
//           <div>
//             <h2 className="text-xl font-semibold">
//               {editData ? "Edit Banner" : "Add Banner"}
//             </h2>
//           </div>

//           <button onClick={close}>
//             <X />
//           </button>
//         </div>

//         <div className="mb-5">
//           <label className="text-sm font-medium">Banner Title</label>
//           <input
//             className="w-full border rounded-md p-3 mt-2"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//           />
//         </div>

//         <div className="mb-5">
//           <label className="text-sm font-medium">Upload Banner Image</label>

//           <label className="border-dashed border-2 rounded-lg p-10 flex flex-col items-center mt-2 cursor-pointer">
//             {preview ? (
//               <img
//                 src={preview}
//                 className="h-32 object-cover rounded-md"
//               />
//             ) : (
//               <>
//                 <UploadCloud size={30} className="text-green-600 mb-2" />
//                 <p>Click or drag image to upload</p>
//               </>
//             )}
//             <input type="file" hidden onChange={uploadImage} />
//           </label>
//         </div>

//         <div className="mb-6">
//           <label className="text-sm font-medium">Placement</label>
//           <select
//             className="w-full border rounded-md p-3 mt-2"
//             value={placement}
//             onChange={(e) => setPlacement(e.target.value)}
//           >
//             <option>Home Page</option>
//             <option>About us</option>
//           </select>
//         </div>

//         <div className="flex justify-between items-center border-t pt-4">
//           <button onClick={close}>Cancel</button>

//           <button
//             onClick={saveBanner}
//             className="bg-[#3fa000] text-white px-6 py-2 rounded-md"
//           >
//             Save Banner
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }}

// import { useState, useEffect } from "react";
// import { X, UploadCloud } from "lucide-react";
// import toast from "react-hot-toast";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";

// export default function AddBannerModal({ close, refresh, editData }) {
//   const [title, setTitle] = useState("");
//   const [placement, setPlacement] = useState("Home Top");
//   const [image, setImage] = useState(null);
//   const [preview, setPreview] = useState("");

//   useEffect(() => {
//     if (editData) {
//       setTitle(editData.title);
//       setPlacement(editData.placement);
//       setPreview(editData.image?.url || editData.image);
//     }
//   }, [editData]);

//   const uploadImage = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImage(file);
//     setPreview(URL.createObjectURL(file));
//   };

//   const saveBanner = async () => {
//     try {
//       if (!title) {
//         toast.error("Fill all fields");
//         return;
//       }

//       const formData = new FormData();
//       formData.append("title", title);
//       formData.append("placement", placement);

//       if (image) {
//         formData.append("image", image);
//       } else if (editData?.image?.url) {
//         formData.append("imageUrl", editData.image.url);
//       }

//       if (editData) {
//         await api({
//           url: SummaryApi.updateBanner.url(editData._id),
//           method: SummaryApi.updateBanner.method,
//           data: formData,
//         });

//         toast.success("Banner updated successfully");
//       } else {
//         await api({
//           url: SummaryApi.createBanner.url,
//           method: SummaryApi.createBanner.method,
//           data: formData,
//         });

//         toast.success("Banner added successfully");
//       }
//       refresh();
//       close();
//     } catch (error) {
//       console.error("Banner save error:", error);
//       toast.error("Something went wrong");
//     }
//   };
//   return (
//     <div className="fixed inset-0 bg-black/40 z-[9999] overflow-y-auto p-4 flex items-start md:items-center justify-center">
//       <div className="bg-white w-full max-w-2xl rounded-2xl p-6 max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-start mb-6">
//           <div>
//             <h2 className="text-xl font-semibold">
//               {editData ? "Edit Banner" : "Add Banner"}
//             </h2>
//           </div>

//           <button onClick={close}>
//             <X />
//           </button>
//         </div>

//         <div className="mb-5">
//           <label className="text-sm font-medium">Banner Title</label>
//           <input
//             className="w-full border rounded-md p-3 mt-2"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//           />
//         </div>

//         <div className="mb-5">
//           <label className="text-sm font-medium">Upload Banner Image</label>

//           <label className="border-dashed border-2 rounded-lg p-10 flex flex-col items-center mt-2 cursor-pointer">
//             {preview ? (
//               <img
//                 src={preview}
//                 alt="Preview"
//                 className="h-32 object-cover rounded-md"
//               />
//             ) : (
//               <>
//                 <UploadCloud size={30} className="text-green-600 mb-2" />
//                 <p>Click or drag image to upload</p>
//               </>
//             )}
//             <input type="file" hidden onChange={uploadImage} />
//           </label>
//         </div>

//         <div className="mb-6">
//           <label className="text-sm font-medium">Placement</label>
//           <select
//             className="w-full border rounded-md p-3 mt-2"
//             value={placement}
//             onChange={(e) => setPlacement(e.target.value)}
//           >
//             <option>Home Page</option>
//             <option>About us</option>
//           </select>
//         </div>

//         <div className="flex justify-between items-center border-t pt-4">
//           <button onClick={close}>Cancel</button>

//           <button
//             onClick={saveBanner}
//             className="bg-[#3fa000] text-white px-6 py-2 rounded-md"
//           >
//             Save Banner
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }




import { useState, useEffect } from "react";
import { X, UploadCloud, Loader2 } from "lucide-react"; // Added Loader2
import toast from "react-hot-toast";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";

const AddBannerModal = ({ close, refresh, editData }) => {
  const [title, setTitle] = useState("");
  const [placement, setPlacement] = useState("Home Top");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");

  // NEW: Loading state for save/update
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (editData) {
      setTitle(editData.title);
      setPlacement(editData.placement);
      setPreview(editData.image?.url || editData.image);
    }
  }, [editData]);

  const uploadImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const saveBanner = async () => {
    if (!title || (!image && !editData?.image?.url)) {
      toast.error("Please fill title and upload image");
      return;
    }

    setIsSubmitting(true); // Start loading
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("placement", placement);

      if (image) {
        formData.append("image", image);
      } else if (editData?.image?.url) {
        formData.append("imageUrl", editData.image.url);
      }

      if (editData) {
        await api({
          url: SummaryApi.updateBanner.url(editData._id),
          method: SummaryApi.updateBanner.method,
          data: formData,
        });
        toast.success("Banner updated successfully");
      } else {
        await api({
          url: SummaryApi.createBanner.url,
          method: SummaryApi.createBanner.method,
          data: formData,
        });
        toast.success("Banner added successfully");
      }
      refresh();
      close();
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setIsSubmitting(false); // End loading
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-[9999] overflow-y-auto p-4 flex items-center justify-center backdrop-blur-sm">
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl animate-in fade-in zoom-in duration-200 overflow-hidden">

        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b bg-gray-50">
          <h2 className="text-xl font-bold text-gray-800">{editData ? "Edit Banner" : "Add Banner"}</h2>
          <button onClick={close} disabled={isSubmitting} className="p-1 hover:bg-gray-200 rounded-full transition-colors">
            <X size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div>
            <label className="text-sm font-bold text-gray-600 uppercase tracking-wider">Banner Title</label>
            <input
              disabled={isSubmitting}
              className="w-full border rounded-lg p-3 mt-2 outline-none focus:ring-2 ring-gray-200 disabled:bg-gray-50"
              placeholder="e.g. Summer Special Offer"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div>
            <label className="text-sm font-bold text-gray-600 uppercase tracking-wider">Banner Image (1920x800px)</label>
            <label className={`border-dashed border-2 rounded-xl p-6 flex flex-col items-center justify-center mt-2 transition-all ${isSubmitting ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-gray-50"}`}>
              {preview ? (
                <img src={preview} alt="Preview" className="h-40 w-full object-cover rounded-lg shadow-sm" />
              ) : (
                <div className="text-center py-4">
                  <UploadCloud size={40} className="text-[#45A301] mx-auto mb-2" />
                  <p className="text-sm font-medium text-gray-600">Click to upload banner image</p>
                  {/* Updated recommended size below */}
                  <p className="text-xs text-gray-400 mt-1">Recommended size: 1920x800px</p>
                </div>
              )}
              <input type="file" hidden onChange={uploadImage} disabled={isSubmitting} accept="image/*" />
            </label>
          </div>

          <div>
            <label className="text-sm font-bold text-gray-600 uppercase tracking-wider">Placement</label>
            <select
              disabled={isSubmitting}
              className="w-full border rounded-lg p-3 mt-2 outline-none focus:ring-2 ring-gray-200 disabled:bg-gray-50"
              value={placement}
              onChange={(e) => setPlacement(e.target.value)}
            >
              <option value="Home Top">Home Page</option>
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end items-center gap-3 p-6 border-t bg-gray-50">
          <button
            disabled={isSubmitting}
            onClick={close}
            className="px-6 py-2 border rounded-md text-sm font-medium hover:bg-white disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            disabled={isSubmitting}
            onClick={saveBanner}
            className="bg-[#45A301] text-white px-8 py-2 rounded-md text-sm font-medium hover:bg-[#3a8a01] transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isSubmitting ? (
              <><Loader2 size={16} className="animate-spin" /> {editData ? "Updating..." : "Saving..."}</>
            ) : (
              editData ? "Update Banner" : "Save Banner"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddBannerModal